import { useState, useEffect, useMemo, useCallback } from 'react';

import {
  getSubscriptionPauseThresholds,
  pauseSubscription,
  resumeSubscription,
  cancelPauseSubscription,
} from 'Api/AccountApi';

export const usePauseSubscription = (getThresholds = false) => {
  const [pauseState, setPauseState] = useState({
    noOfDaysLeft: 0,
    noOfTimesLeft: 0,
    isReady: false,
  });

  const pause = useCallback((payload) => pauseSubscription(payload), []);
  const resume = useCallback((payload) => resumeSubscription(payload), []);
  const cancelPause = useCallback((payload) => cancelPauseSubscription(payload), []);

  useEffect(() => {
    if (getThresholds) {
      getSubscriptionPauseThresholds().then(({ noOfDaysLeft, noOfTimesLeft }) => {
        setPauseState({ noOfDaysLeft, noOfTimesLeft, isReady: true });
      });
    } else {
      setPauseState({ noOfDaysLeft: 0, noOfTimesLeft: 0, isReady: true });
    }
  }, [getThresholds]);

  const pauseActions = useMemo(
    () => ({
      pause,
      resume,
      cancelPause,
    }),
    [pause, resume, cancelPause]
  );

  return [pauseState, pauseActions];
};
